import { Report, ValueGroups } from '../../components/StageZero/types';

export enum MissionsTypes {
    GET_LIST = '@missions/GET_LIST',
    REQUEST_GET_LIST = '@missions/REQUEST_GET_LIST',
    SAVE_MISSION = '@missions/SAVE_MISSION',
    REQUEST_SAVE_MISSION = '@missions/REQUEST_SAVE_MISSION',
    SAVE_STAGE = '@missions/SAVE_STAGE',
    REQUEST_SAVE_STAGE = '@missions/REQUEST_SAVE_STAGE',
    UPDATE_REWARDS = '@missions/UPDATE_REWARDS',
    REQUEST_UPDATE_REWARDS = '@missions/REQUEST_UPDATE_REWARDS',
}

export type Skill = {
    id: string;
    image: string;
    name: Record<string, string>;
};

export type Mission = {
    stagesTitle: Record<string, string>;
    description?: Record<string, string>;
    image?: string;
    id: string;
    exercisesTitle: Record<string, string>;
    name: Record<string, string>;
    publishFrom: Date | null;
    publishTo: Date | null;
    rewards: string[];
    skills: Skill[];
    type: string;
    stages: Stage[];
    isSurveyDifferent: boolean;
    paid?: boolean;
    price?: number;
};

export type Stage = {
    id: string;
    description?: Record<string, string>;
    surveyDescription?: Record<string, string>;
    name: Record<string, string>;
    exercises?: string[];
    image?: string;
    order: number;
    stageExitSurvey?: boolean;
    reports?: Report[];
    valueGroups?: ValueGroups[];
    maxPoints?: number;
};

export type StageExtendend = {
    id: string;
    description?: Record<string, string>;
    surveyDescription?: Record<string, string>;
    name: Record<string, string>;
    exercises?: string[];
    image?: string;
    order: number;
    stageExitSurvey?: boolean;
    edit: boolean;
};

export type MissionsState = {
    isLoading: boolean;
    missions: Mission[];
};

export type MissionsAction<Payload> = {
    type: MissionsTypes;
    payload: Payload;
};

export type MissionReducer = (state: MissionsState, actions: MissionsAction<MissionsState>) => MissionsState;
